<script setup lang="ts">
import V2PandaUpdatesView from '@/components/admin/views/V2PandaUpdatesView.vue'
</script>

<template>
  <V2PandaUpdatesView />
</template>
